import React, {useEffect, useState} from "react";

export default function ClassicoHoseBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M222.143,246.14l-0.14-0.6c-1.09-4.51-2.38-9.14-3.919-14.16c-1.471-4.75-3.091-9.57-4.961-14.76
   c-1.75-4.86-3.63-9.78-5.74-15.04c-1.95-4.85-4.07-9.9-6.31-15.03c-2.07-4.75-4.31-9.71-6.63-14.72c-2.14-4.6-4.41-9.35-6.73-14.1
   c-2.129-4.35-4.35-8.79-6.59-13.2c-2.02-3.96-4.11-7.99-6.22-11.99c-1.84-3.49-3.73-7.02-5.609-10.49
   c-1.571-2.9-3.161-5.79-4.771-8.67c-1.22-2.2-2.46-4.39-3.7-6.57c-0.79-1.39-1.58-2.78-2.39-4.16c-0.26-0.46-0.53-0.92-0.8-1.38
   v-0.13c0.47-14.96,0.97-33.61,1.05-36.58h0.01V45.45c0-0.38-0.24-0.72-0.6-0.86c-7.06-2.26-14.21-4.22-21.12-6.12
   c-2.85-0.78-5.71-1.56-8.6-2.38c-21.36-6.01-43.6-11.16-67.99-15.74c-1.04-0.2-1.71-0.1-2.18,0.33c-0.45,0.41-0.659,1.09-0.82,1.99
   c-0.27,1.4-0.54,2.8-0.83,4.2l-0.32,1.61c-0.91,4.84-1.96,8.68-3.31,12.09c-0.06,0.14-0.06,0.25-0.05,0.34l-3.23,6.92
   c-25.32,46.47-16.27,86.62-14.2,94.19c0.22,0.8,0.37,1.62,0.45,2.44c0.41,4.4,1.36,16.58,1.27,34.66
   c-0.09,18.67,1.51,39.75,2.46,52.34c0.211,2.71,0.39,5.08,0.52,7.02c0.81,11.83-0.15,26.68-0.47,30.95
   c-0.27,3.72-0.17,16.39-0.03,26.37c0.08,5.55-0.599,11.07-2.02,16.43c-2.61,9.82-6.09,23.89-7.87,35.18
   c-2.81,17.7-7.16,59.49-7.209,59.9c-0.061,0.54-6.771,53.58-7.201,62.32l-0.009,0.24l0.219,0.08c19.781,7.66,36.8,9.48,48.52,9.48
   c1.261,0,2.46-0.02,3.59-0.06c12.54-0.41,20.69-2.87,21.131-3.4c0.619-0.74,4-15.66,5.419-32.04c1.4-16.15,10.59-54.33,10.69-54.72
   c0.11-0.52,11.48-52.21,12.46-59.78c0.98-7.62,5.56-43.65,6.31-50.01c0.75-6.36,4.97-27.94,5.6-31.16
   c3.48,1.64,4.82,6.09,5.67,10.28l1.04,5.11c2.88,14.1,5.86,28.69,7.561,43.24c0.889,7.56,0.79,15.17,0.699,22.53
   c-0.05,3.4-0.09,6.91-0.04,10.39c0.11,8.24,0.47,16.43,0.83,24.1c0.49,10.63,1.04,20.07,1.67,28.85
   c1.07,15.09,1.19,50.25,1.2,50.66c0.05,0.26,0.76,2.56,10.42,3.85c10.16,1.36,20.35,1.78,35.61,2.09c0.49,0.01,0.99,0.01,1.47,0.01
   c15.3,0,24.98-4.8,25.08-4.85l0.16-0.08l0.02-0.18c0.02-0.25,2.06-25.11,1.2-33.01c-0.91-8.32-0.91-28.48,0.971-38.2
   c0.069-0.33,0.119-0.67,0.159-1.01c0.27-2.04,0.38-4.12,0.49-6.14l0.01-0.22c0.19-3.51,0.31-6.98,0.4-9.91
   c0.12-3.74,0.22-7.72,0.32-12.54c0.1-4.74,0.18-9.48,0.25-14.22c0.07-4.99,0.13-9.99,0.18-14.98c0.05-4.93,0.09-9.87,0.12-14.8
   c0.04-4.56,0.06-9.12,0.08-13.68c0.02-3.88,0.04-7.76,0.05-11.63l0.01-4.76c0-0.76,0.01-1.52,0.02-2.28
   c0.04-2.3,0.07-4.68-0.15-7.04C224.353,255.25,223.233,250.62,222.143,246.14z"
        />
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M484.843,234.37c0-0.62-0.21-62.15-3.98-122.56c-2.77-44.57-8.34-64.27-11.46-72.11
   c0.29-0.91,0.31-2.28,0.32-2.62c0-0.53-0.01-13.08-0.38-15.77c-0.39-2.8-1.85-3.84-1.91-3.88l-0.08-0.05l-2.18-0.11l-0.01,0.32
   l-0.01-0.32c-73.64,1.44-144.48,0.9-159.46,0.67l-2.52-0.05c-0.77,0.02-1.47,0.42-1.93,1.1c-0.51,0.75-0.86,1.66-1.03,2.72
   c-0.42,2.62-0.67,14.89-0.68,15.41c0,0.35,0,1.81,0.32,2.69c-3.05,7.95-8.47,27.73-11.23,72c-0.59,9.41-1.12,19.43-1.59,29.77
   l-0.18,3.95c-0.4,9.16-0.75,18.75-1.06,28.49l-0.17,6c-0.9,31.23-0.97,54.12-0.97,54.34l-1.11,62.44c-0.03,2.1,0.03,4.22,0.2,6.3
   c0.47,5.85,0.73,19.07,0.94,29.7c0.16,7.8,0.29,14.54,0.47,16.69c0.49,6.05,1.51,45.52,1.52,45.92c0.02,0.53,1.3,54.01,1.79,62.53
   c0.49,8.6,1.32,16.46,1.85,17.51c0.44,0.87,14.59,2.62,26.57,3.28c4,0.22,8.46,0.38,13.06,0.38c10.28,0,21.22-0.79,29.09-3.42
   c0.25-0.08,0.44-0.3,0.49-0.56c0.89-5.05,4.93-40.46,5.59-60.42c0.66-19.66,0.31-68.79-0.22-75.09c-0.52-6.3,0.21-38.14,1.85-46.16
   c1.03-5.06,2.13-19.64,3.02-31.35c0.54-7.11,1-13.25,1.31-15.44c0.29-1.99,0.39-5.78,0.53-10.59c0.25-8.98,0.6-21.27,2.45-28.12
   c1.98-7.35,3.3-15.97,4.09-21.13c0.33-2.14,0.56-3.68,0.71-4.21c0.11-0.4,0.17-1.73,0.28-4.45c0.34-8.18,1.14-27.33,5.64-29.25
   c4.45,1.92,5.25,21.07,5.59,29.25c0.064,1.597,0.112,2.704,0.162,3.435l-0.076-0.004l-0.047,0.937l0.227,0.011
   c0.005,0.022,0.009,0.052,0.014,0.071c0.14,0.53,0.38,2.07,0.71,4.21c0.04,0.26,0.08,0.54,0.12,0.81c-0.01,0.23-0.02,0.38-0.02,0.4
   h0.08c0.81,5.23,2.08,13.12,3.91,19.92c1.85,6.85,2.2,19.14,2.45,28.12c0.13,4.81,0.24,8.6,0.52,10.59
   c0.32,2.19,0.79,8.46,1.33,15.73c0.88,11.93,1.99,26.77,3.02,31.82c1.65,8.08,2.04,39.98,1.52,46.17
   c-0.36,4.35,0.67,31.22,1.51,52.82c0.31,8.1,0.6,15.75,0.78,21.18c0.66,19.75,2.48,55.56,3.4,60.74c0.05,0.26,0.23,0.48,0.49,0.56
   c11.39,3.81,29.21,3.75,42.15,3.04c11.98-0.66,26.13-2.41,26.57-3.28c0.52-1.05,1.35-8.9,1.85-17.51
   c0.49-8.52,1.14-61.89,1.14-62.43c0.01-0.39,0.82-39.75,1.31-45.8c0.35-4.31,1.42-26.84,2.06-40.3c0.25-5.3,0.43-9.13,0.46-9.49
   L484.843,234.37z"
        />
      </g>
      <path
        fill="#F4F4F4"
        d="M481.813,141.659l-6.67-0.02v-1.09h6.62C481.773,140.919,481.793,141.289,481.813,141.659"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M483.203,179.539h-0.97c-0.44-0.5-2.08-1.79-4.32-3.56c-1.26-0.99-2.56-2.01-2.88-2.33l0.1-31.36l6.71,0.02
 c0.56,12.43,0.98,24.43,1.31,35.45l-0.01-0.01l-0.03-0.02l-0.42,0.5l0.03,0.02c0.05,0.05,0.1,0.08,0.13,0.11l0.03,0.03l0.28-0.33
 C483.173,178.549,483.193,179.049,483.203,179.539"
      />
      <path
        fill="#F4F4F4"
        d="M291.943,140.439l-0.04,1.08l-4.21-0.12c0.021-0.37,0.03-0.74,0.05-1.11L291.943,140.439z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M291.883,142.138l-0.96,31.39c-0.33,0.3-1.66,1.27-2.94,2.21c-0.54,0.4-1.09,0.8-1.62,1.2l0.08-2.89
 c0.31-9.74,0.66-19.32,1.06-28.48l0.16-3.53L291.883,142.138z"
      />
      <polygon
        fill="#F4F4F4"
        points="466.503,60.749 396.493,64.009 396.453,63.169 466.473,60.069 "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M467.563,82.999c-0.4,0.36-1.27,1.26-3.36,3.44c-1.39,1.46-2.94,3.08-3.34,3.5l-55.94,2.59
 c-0.69-0.56-5.089-4.28-6.79-5.71v-0.03h-0.03c-0.26-0.21-0.45-0.38-0.55-0.46l-1.03-21.67l70.01-3.27L467.563,82.999z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M373.263,64.659l-1.03,21.66c-0.11,0.1-0.3,0.26-0.55,0.47h-0.03v0.03c-1.71,1.44-6.1,5.15-6.79,5.71
 l-55.95-2.59c-0.4-0.43-1.95-2.06-3.34-3.5c-2.08-2.18-2.95-3.09-3.35-3.44l1.02-21.61L373.263,64.659z"
      />
      <polygon
        fill="#F4F4F4"
        points="373.323,63.169 373.293,64.009 303.273,60.749 303.303,60.069 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.237,0.928"
        d="M479.185,464.588
 c0,0-28.792,9.026-69.082-0.106"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.928,0.928"
        d="M390.627,182.558
 c0,0,1.49-29.73,1.129-33.088c-0.36-3.358-4.91-5.503-7.031-4.87h-0.092c-2.121-0.633-6.671,1.512-7.031,4.87
 c-0.361,3.358,1.129,33.088,1.129,33.088"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.237,0.928"
        d="M290.062,464.567
 c0,0,29.392,9.003,69.683-0.13"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.928,0.928"
        d="M379.64,164.815
 v-12.563c0-1.614,0.602-3.187,1.741-4.332c0.784-0.786,1.768-1.212,3.191-1.227"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.928,0.928"
        d="M389.807,164.926
 l-0.175-12.737c0-1.615-0.601-3.188-1.741-4.332c-0.783-0.786-1.768-1.212-3.191-1.227"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.93,0.929"
        x1="383.552"
        y1="38.927"
        x2="383.552"
        y2="142.135"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.93,0.929"
        x1="382.398"
        y1="38.927"
        x2="382.398"
        y2="142.407"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 359.104,19.672 313.077,19.672 309.227,19.612 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="392.621"
        y1="19.691"
        x2="375.495"
        y2="19.799"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M359.464,35.866
 c-2.977-0.055-5.58-0.11-8.557-0.166c-4.529-0.084-9.058-0.167-13.587-0.251c-4.167-0.078-8.335-0.155-12.502-0.232
 c-3.053-0.057-6.105-0.113-9.158-0.169c-1.184-0.022-2.369-0.044-3.554-0.066l-4.884-0.22"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M392.482,36.361
 c-0.387-0.003-0.774-0.005-1.16-0.006c-3.458-0.005-6.915-0.032-10.372-0.078c-1.365-0.019-3.854-0.042-5.219-0.067"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M461.726,34.763
 c-4.115,0-3.998,0.186-4.059,0.187c-1.83,0.042-3.659,0.085-5.489,0.127c-3.72,0.087-7.44,0.173-11.16,0.26
 c-4.72,0.11-9.441,0.219-14.162,0.329l-14.497,0.337c-1.266,0.03-2.535,0.052-3.803,0.078"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="408.53"
        y1="19.617"
        x2="460.416"
        y2="19.426"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M408.99,138.514
 c-1.551-1.708-4.556-5.027-5.926-6.546l-1.825-38.081c0.144,0.121,0.282,0.237,0.413,0.347c0.357,0.299,0.654,0.548,0.863,0.723
 c0.109,0.09,0.2,0.166,0.266,0.219c0.658,0.541,1.389,0.797,2.174,0.762c0.044-0.002,0.089-0.005,0.133-0.009l56.084-2.601
 l1.241-0.065l0.844-0.902c0.074-0.079,0.72-0.756,1.585-1.663l1.834,38.283c-0.532,0.695-1.32,1.725-2.138,2.793l-0.887,1.158
 c-1.161,1.515-1.907,2.488-2.391,3.122L408.99,138.514z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M408.202,140.413
 c-1.344-1.477-5.809-6.408-6.964-7.693l-2.062-43.005c0.6,0.507,1.064,0.898,1.077,0.909c0.944,0.796,1.886,1.59,2.594,2.185
 c0.355,0.297,0.651,0.545,0.859,0.718c0.104,0.088,0.189,0.158,0.249,0.206c0.126,0.105,0.448,0.367,0.917,0.346
 c0.027-0.001,0.054-0.003,0.08-0.006l56.116-2.603l0.498-0.026l0.336-0.359c0.092-0.097,2.633-2.765,4.591-4.804l2.073,43.289
 c-0.462,0.606-1.478,1.933-2.544,3.324l-0.891,1.164c-1.717,2.241-2.524,3.294-2.918,3.813L408.202,140.413z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M406.141,89.72
 c-1.205-1.011-5.63-4.995-5.63-4.995l-0.828-17.456l64.514-3.009l0.838,17.623c-0.054,0.055-0.11,0.113-0.167,0.172
 c-0.623,0.643-1.441,1.496-2.37,2.466c-0.917,0.958-1.9,1.988-2.584,2.705L406.141,89.72z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M405.224,91.624
 c-1.043-0.869-4.175-3.513-6.213-5.236l-0.586-0.546l-0.967-20.332l68.23-3.183l0.964,20.287c-0.189,0.193-0.437,0.448-0.727,0.747
 c-0.619,0.641-1.436,1.491-2.361,2.458c-1.186,1.238-2.483,2.598-3.096,3.242L405.224,91.624z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="402.843"
        y1="109.002"
        x2="464.76"
        y2="106.259"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M360.794,138.514
 c1.551-1.708,4.556-5.027,5.926-6.546l1.826-38.081c-0.145,0.121-0.283,0.237-0.413,0.347c-0.357,0.299-0.654,0.548-0.864,0.723
 c-0.108,0.09-0.2,0.166-0.266,0.219c-0.658,0.541-1.389,0.797-2.173,0.762c-0.045-0.002-0.089-0.005-0.134-0.009l-56.083-2.601
 l-1.241-0.065l-0.844-0.902c-0.075-0.079-0.72-0.756-1.586-1.663l-1.833,38.283c0.531,0.695,1.32,1.725,2.138,2.793l0.887,1.158
 c1.16,1.515,1.906,2.488,2.39,3.122L360.794,138.514z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M361.582,140.413
 c1.345-1.477,5.809-6.408,6.964-7.693l2.063-43.005c-0.601,0.507-1.065,0.898-1.078,0.909c-0.943,0.796-1.886,1.59-2.594,2.185
 c-0.355,0.297-0.65,0.545-0.859,0.718c-0.104,0.088-0.189,0.158-0.249,0.206c-0.126,0.105-0.448,0.367-0.917,0.346
 c-0.027-0.001-0.054-0.003-0.08-0.006l-56.116-2.603l-0.498-0.026l-0.336-0.359c-0.091-0.097-2.633-2.765-4.591-4.804l-2.072,43.289
 c0.462,0.606,1.477,1.933,2.543,3.324l0.892,1.164c1.716,2.241,2.523,3.294,2.918,3.813L361.582,140.413z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M363.644,89.72
 c1.205-1.011,5.63-4.995,5.63-4.995l0.827-17.456l-64.513-3.009l-0.838,17.623c0.054,0.055,0.11,0.113,0.167,0.172
 c0.622,0.643,1.441,1.496,2.37,2.466c0.917,0.958,1.9,1.988,2.584,2.705L363.644,89.72z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M364.561,91.624
 c1.043-0.869,4.175-3.513,6.213-5.236l0.587-0.546l0.966-20.332l-68.23-3.183l-0.964,20.287c0.189,0.193,0.437,0.448,0.727,0.747
 c0.62,0.641,1.436,1.491,2.362,2.458c1.185,1.238,2.483,2.598,3.096,3.242L364.561,91.624z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="366.941"
        y1="109.002"
        x2="305.024"
        y2="106.259"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 285.523,230.124 313.625,231.08 316.291,152.7 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="292.357"
        y1="168.563"
        x2="314.396"
        y2="169.313"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="292.501"
        y1="164.327"
        x2="314.541"
        y2="165.077"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 315.229,152.156 317.128,152.99 315.224,152.741 317.11,153.96 315.206,153.711 317.098,154.737 315.194,154.488 317.086,155.513 
 315.182,155.265 317.074,156.289 315.17,156.042 317.062,157.065 315.159,156.818 317.05,157.841 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M289.888,142.484
 l-0.94,30.599c-0.235,0.181-1.21,0.902-2.328,1.729"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="287.649"
        y1="146.616"
        x2="289.266"
        y2="146.671"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="291.18"
        y1="175.631"
        x2="289.367"
        y2="228.917"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M464.776,39.574
 c0.279-0.924,0.287-2.482,0.287-2.482s0-13.032-0.374-15.727c-0.183-1.317-0.61-2.22-0.999-2.8"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M467.174,39.574
 c0.279-0.924,0.288-2.482,0.288-2.482s0-13.032-0.374-15.727c-0.184-1.317-0.61-2.22-1-2.8"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M305.954,19.079
 c-0.45,0.577-0.976,1.509-1.199,2.883c-0.426,2.625-0.676,15.365-0.676,15.365s-0.016,1.099,0.14,1.989"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M303.714,19.079
 c-0.451,0.577-0.976,1.509-1.199,2.883c-0.426,2.625-0.676,15.365-0.676,15.365s-0.016,1.099,0.14,1.989"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="366.125"
        y1="19.642"
        x2="366.125"
        y2="39.666"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="369.013"
        y1="19.642"
        x2="369.013"
        y2="39.666"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="398.791"
        y1="19.642"
        x2="398.791"
        y2="39.666"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="401.902"
        y1="19.642"
        x2="401.902"
        y2="39.666"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="192.681"
        x2="449.64"
        y2="192.077"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="190.889"
        x2="449.64"
        y2="190.88"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.197,1.186"
        x1="449.64"
        y1="190.88"
        x2="449.64"
        y2="152.582"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="152.581"
        x2="449.64"
        y2="151.977"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="231.171"
        x2="449.64"
        y2="230.567"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="229.375"
        x2="449.64"
        y2="229.365"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="449.64"
        y1="229.365"
        x2="449.64"
        y2="195.696"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="449.64"
        y1="195.696"
        x2="449.64"
        y2="195.092"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="472.839"
        y1="231.171"
        x2="472.839"
        y2="230.567"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="472.839"
        y1="229.375"
        x2="472.839"
        y2="229.365"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="472.839"
        y1="229.365"
        x2="472.839"
        y2="195.696"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="472.839"
        y1="195.696"
        x2="472.839"
        y2="195.092"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="461.239"
        y1="231.171"
        x2="461.239"
        y2="230.567"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="461.239"
        y1="229.375"
        x2="461.239"
        y2="229.365"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="461.239"
        y1="229.365"
        x2="461.239"
        y2="195.696"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="461.239"
        y1="195.696"
        x2="461.239"
        y2="195.092"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="473.77"
        y1="168.645"
        x2="450.721"
        y2="168.645"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="473.77"
        y1="164.406"
        x2="450.721"
        y2="164.406"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 450.72,151.469 448.793,152.239 450.705,152.054 448.779,153.208 450.691,153.024 448.764,153.985 450.676,153.802 448.75,154.761 
 450.661,154.578 448.736,155.537 450.646,155.355 448.721,156.313 450.632,156.132 448.707,157.089 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M477.124,142.664
 l-0.102,30.613c0.523,0.432,4.826,3.823,5.912,4.725"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="481.879"
        y1="146.871"
        x2="477.603"
        y2="146.871"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="474.705"
        y1="192.681"
        x2="474.705"
        y2="175.139"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="450.393"
        y1="203.475"
        x2="450.997"
        y2="203.475"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="452.197"
        y1="203.475"
        x2="452.207"
        y2="203.475"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.211,1.2,0.01,0"
        x1="452.207"
        y1="203.475"
        x2="471.569"
        y2="203.475"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="471.569"
        y1="203.475"
        x2="472.173"
        y2="203.475"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="450.393"
        y1="205.915"
        x2="450.997"
        y2="205.915"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="452.197"
        y1="205.915"
        x2="452.207"
        y2="205.915"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.211,1.2,0.01,0"
        x1="452.207"
        y1="205.915"
        x2="471.569"
        y2="205.915"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="471.569"
        y1="205.915"
        x2="472.173"
        y2="205.915"
      />
      <path
        fill="#F4F4F4"
        d="M73.473,69.678l-0.09,0.84l-31.9-3.21c0.09-0.24,0.18-0.49,0.27-0.74L73.473,69.678z"
      />
      <polygon
        fill="#F4F4F4"
        points="133.733,155.869 133.584,157.169 77.803,150.729 77.923,149.649 "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M133.513,157.808l-3.59,31.3c-0.26,0.27-1.37,1.18-2.45,2.05c-1.52,1.22-3.08,2.49-3.53,3l-43.94-5.05
 c-0.35-0.55-1.68-2-3.5-3.96c-1.03-1.11-2.09-2.26-2.35-2.6l3.58-31.179L133.513,157.808z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M116.003,53.259c-2.59,12.29-11.88,50.88-28.52,64.48c-3.92-31.97-4.68-42.69,2.8-70.16
 c0.97,0.17,1.93,0.34,2.9,0.52c3.05,0.55,8.03,1.63,13.31,2.87l5.12,1.2C113.013,52.519,114.482,52.879,116.003,53.259"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M73.323,71.159l-2.19,21.58c-0.11,0.09-0.31,0.24-0.57,0.43h-0.03v0.03c-1.78,1.35-6.37,4.82-7.08,5.35
 l-29.25-2.93c1.24-8.52,3.44-17.84,7.04-27.68L73.323,71.159z"
      />
      <path
        fill="#010101"
        d="M155.214,49.939c-1.06,0-1.64,1.78-1.64,3.46c0,1.67,0.58,3.45,1.64,3.45c1.07,0,1.64-1.78,1.64-3.45
 C156.854,51.719,156.283,49.939,155.214,49.939 M155.214,56.198c-0.4,0-0.99-1.09-0.99-2.8c0-1.72,0.59-2.81,0.99-2.81
 c0.41,0,0.99,1.09,0.99,2.81C156.203,55.108,155.623,56.198,155.214,56.198"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M91.047,464.894c0,0-0.207,0.042-0.6,0.113"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="89.227"
        y1="465.22"
        x2="89.226"
        y2="465.22"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.241,1.239"
        d="M89.226,465.22
 c-6.647,1.111-30.208,4.377-49.216-1.396"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M40.009,463.823
 c-0.195-0.06-0.389-0.12-0.583-0.181"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="33.054"
        y1="461.835"
        x2="33.053"
        y2="461.835"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.175,1.173"
        d="M38.666,463.422
 c-3.684-1.124-17.916-5.404-21.143-6.965"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M17.523,456.457
 c-0.203-0.098-0.385-0.192-0.542-0.28"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.221,1.221"
        d="M221.061,434.158
 c0,0-19.013,6.969-40.088,4.161"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.221,1.221"
        d="M180.277,438.227
 c0,0-23.792-1.685-32.123-4.655"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 81.344,26.466 77.326,25.672 59.434,22.29 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 128.153,37.953 115.292,34.291 107.764,32.436 92.189,28.849 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="151.042"
        y1="44.406"
        x2="136.253"
        y2="40.26"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M76.669,43.028
 l-1.961-0.336c0,0-8.183-1.31-19.202-3.164"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M126.277,53.841
 l-12.73-3.403l-7.769-1.815c0,0-9.483-2.384-18.62-3.907"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="150.036"
        y1="60.452"
        x2="133.706"
        y2="55.828"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M36.537,142.189
 l20.394,2.056c1.64-1.623,4.817-4.777,6.266-6.221l3.858-37.929c-0.151,0.114-0.296,0.222-0.432,0.324
 c-0.372,0.281-0.682,0.513-0.901,0.677c-0.113,0.084-0.208,0.155-0.277,0.205c-0.686,0.504-1.429,0.721-2.211,0.644
 c-0.045-0.004-0.089-0.009-0.133-0.016l-29.03-2.906"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M36.77,144.082
 l20.846,2.101c1.421-1.403,6.142-6.089,7.365-7.31l4.356-42.833c-0.627,0.474-1.111,0.839-1.125,0.85
 c-0.984,0.744-1.968,1.486-2.707,2.043c-0.37,0.278-0.679,0.509-0.896,0.671c-0.109,0.082-0.197,0.148-0.26,0.193
 c-0.131,0.098-0.467,0.342-0.933,0.296c-0.027-0.002-0.054-0.006-0.081-0.011l-29.167-2.919"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M34.755,92.907
 l27.626,2.766c1.258-0.946,5.89-4.687,5.89-4.687l1.757-17.387l-29.521-2.964"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M34.628,94.763
 l28.567,2.86c1.088-0.812,4.357-3.285,6.484-4.897l0.616-0.514l2.05-20.251L40.45,68.759"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="64.644"
        y1="115.103"
        x2="33.09"
        y2="112.01"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M119.78,54.404
 c-0.042,0.197-0.083,0.394-0.125,0.591"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="119.407"
        y1="56.159"
        x2="119.405"
        y2="56.169"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.201,1.19"
        d="M119.405,56.169
 c-5.336,24.671-15.287,53.107-28.805,63.703c0,0-1.307,1.298-3.014,1.659"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M87.585,121.531
 c-0.196,0.042-0.397,0.07-0.603,0.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="88.169"
        y1="118.562"
        x2="91.265"
        y2="118.562"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M127.8,58.983
 c0.089-0.165,0.173-0.354,0.251-0.553"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="128.41"
        y1="57.317"
        x2="128.412"
        y2="57.308"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.179,1.168"
        d="M128.413,57.308
 c0.109-0.403,0.172-0.698,0.172-0.698s2.642-12.76,2.823-15.476c0.065-0.984-0.048-1.772-0.218-2.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M131.191,38.761
 c-0.06-0.213-0.126-0.403-0.194-0.571"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M130.08,59.676
 c0.089-0.165,0.174-0.354,0.251-0.553"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="130.69"
        y1="58.01"
        x2="130.692"
        y2="58.001"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.179,1.168"
        d="M130.692,58.001
 c0.11-0.403,0.173-0.698,0.173-0.698s2.641-12.76,2.822-15.477c0.066-0.983-0.047-1.771-0.217-2.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M133.471,39.453
 c-0.06-0.212-0.126-0.402-0.195-0.57"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M82.69,47.763
 c-0.038-0.186-0.058-0.392-0.065-0.604"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="82.675"
        y1="45.97"
        x2="82.676"
        y2="45.96"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.2,1.189"
        d="M82.676,45.96
 c0.045-0.422,0.101-0.724,0.101-0.724s2.504-12.967,3.526-15.54c0.38-0.955,0.901-1.619,1.405-2.076"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M87.706,27.623
 c0.16-0.145,0.317-0.269,0.468-0.374"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M80.403,47.547
 c-0.039-0.187-0.062-0.392-0.072-0.603"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="80.373"
        y1="45.725"
        x2="80.374"
        y2="45.715"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.23,1.219,0.01,0"
        d="
 M80.374,45.715c0.044-0.439,0.102-0.755,0.102-0.755s2.515-13.27,3.563-15.901c0.393-0.985,0.938-1.666,1.464-2.131"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        d="M85.501,26.93
 c0.16-0.142,0.319-0.264,0.473-0.369"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M153.903,45.052
 c-0.574,0.752-1.093,1.389-1.829,2.486c-0.865,1.29-1.564,2.445-1.776,4.009c-0.227,1.672,0.048,3.414,0.817,4.941
 c0.82,1.628,1.676,3.251,2.51,4.882l3.228,0.828"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="153.903"
        y1="45.052"
        x2="157.372"
        y2="45.986"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="49.069"
        y1="198.884"
        x2="49.136"
        y2="198.283"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="49.268"
        y1="197.104"
        x2="49.269"
        y2="197.094"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.197,1.186"
        x1="49.269"
        y1="197.095"
        x2="53.514"
        y2="159.032"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="53.514"
        y1="159.032"
        x2="53.581"
        y2="158.431"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="44.803"
        y1="237.138"
        x2="44.87"
        y2="236.537"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="45.002"
        y1="235.353"
        x2="45.003"
        y2="235.343"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="45.004"
        y1="235.343"
        x2="48.736"
        y2="201.881"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="48.735"
        y1="201.881"
        x2="48.802"
        y2="201.28"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="65.773"
        y1="239.476"
        x2="65.84"
        y2="238.875"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="65.971"
        y1="237.691"
        x2="65.972"
        y2="237.681"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="65.973"
        y1="237.682"
        x2="69.705"
        y2="204.22"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="69.705"
        y1="204.22"
        x2="69.771"
        y2="203.619"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="55.288"
        y1="238.307"
        x2="55.355"
        y2="237.706"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="55.487"
        y1="236.522"
        x2="55.488"
        y2="236.512"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.203,1.192"
        x1="55.488"
        y1="236.512"
        x2="59.22"
        y2="203.05"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="59.22"
        y1="203.05"
        x2="59.287"
        y2="202.449"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M126.82,195.585
 c-1.323,12.638-2.906,26.061-4.319,38.166c-0.559,4.786-1.014,8.683-1.312,11.319l-4.452-0.532"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="73.544"
        y1="177.429"
        x2="52.71"
        y2="175.106"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="74.014"
        y1="173.216"
        x2="53.18"
        y2="170.893"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
 54.614,158.035 52.787,158.607 54.536,158.616 52.666,159.569 54.415,159.578 52.567,160.339 54.315,160.349 52.468,161.109 
 54.216,161.12 52.369,161.879 54.116,161.889 52.27,162.648 54.017,162.66 52.171,163.418 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M79.455,151.947
 l-3.484,30.415c0.444,0.504,4.274,4.649,4.925,5.414l42.37,4.867c0.666-0.582,4.654-3.826,5.303-4.388l3.466-30.247"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="130.906"
        y1="161.917"
        x2="79.422"
        y2="156.176"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 89.186,200.263 83.361,199.613 78.638,241.971 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        points="
 113.265,202.948 118.851,203.571 114.128,245.928 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M111.722,197.674
 l-3.168,28.408c-0.026,0.236-0.252,0.404-0.503,0.376l-19.387-2.162c-0.251-0.028-0.434-0.242-0.408-0.477l3.168-28.409"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="88.002"
        y1="226.459"
        x2="86.229"
        y2="242.364"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="108.264"
        y1="228.681"
        x2="106.491"
        y2="244.587"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        x1="71.725"
        y1="201.411"
        x2="73.669"
        y2="183.977"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="48.554"
        y1="209.689"
        x2="49.155"
        y2="209.756"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="50.377"
        y1="209.892"
        x2="50.387"
        y2="209.893"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.241,1.229,0.01,0"
        x1="50.387"
        y1="209.893"
        x2="67.64"
        y2="211.817"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="67.64"
        y1="211.817"
        x2="68.241"
        y2="211.884"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="48.284"
        y1="212.114"
        x2="48.885"
        y2="212.181"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="50.106"
        y1="212.317"
        x2="50.116"
        y2="212.318"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.241,1.229,0.01,0"
        x1="50.116"
        y1="212.318"
        x2="67.369"
        y2="214.242"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        x1="67.37"
        y1="214.242"
        x2="67.971"
        y2="214.309"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M72.83,252.247
 c18.208,3.361,35.895,4.974,53.239,5.435"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M72.83,256.51
 c16.64,3.002,34.502,4.688,53.239,5.434"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M171.273,249.218
 c0,0,22.907-2.66,47.796-10.852"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.45"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M172.039,253.111
 c0,0,22.852-2.67,47.741-10.861"
      />
      <path
        fill="#010101"
        d="M224.773,259.849c-0.42-4.59-1.54-9.22-2.63-13.7l-0.14-0.6c-1.09-4.51-2.38-9.14-3.919-14.16
 c-1.471-4.75-3.091-9.57-4.961-14.76c-1.75-4.86-3.63-9.78-5.74-15.04c-1.95-4.85-4.07-9.9-6.31-15.03
 c-2.07-4.75-4.31-9.71-6.63-14.72c-2.14-4.6-4.41-9.35-6.73-14.1c-2.129-4.35-4.35-8.79-6.59-13.2c-2.02-3.96-4.11-7.99-6.22-11.99
 c-1.84-3.49-3.73-7.02-5.609-10.49c-1.571-2.9-3.161-5.79-4.771-8.67c-1.22-2.2-2.46-4.39-3.7-6.57c-0.79-1.39-1.58-2.78-2.39-4.16
 c-0.26-0.46-0.53-0.92-0.8-1.38v-0.13c0.47-14.96,0.97-33.61,1.05-36.58h0.01v-19.11c0-0.38-0.24-0.72-0.6-0.86
 c-7.06-2.26-14.21-4.22-21.12-6.12c-2.85-0.78-5.71-1.56-8.6-2.38c-21.36-6.01-43.6-11.16-67.99-15.74c-1.04-0.2-1.71-0.1-2.18,0.33
 c-0.45,0.41-0.659,1.09-0.82,1.99c-0.27,1.4-0.54,2.8-0.83,4.2l-0.32,1.61c-0.91,4.84-1.96,8.68-3.31,12.09
 c-0.06,0.14-0.06,0.25-0.05,0.34l-3.23,6.92c-25.32,46.47-16.27,86.62-14.2,94.19c0.22,0.8,0.37,1.62,0.45,2.44
 c0.41,4.4,1.36,16.58,1.27,34.66c-0.09,18.67,1.51,39.75,2.46,52.34c0.211,2.71,0.39,5.08,0.52,7.02
 c0.81,11.83-0.15,26.68-0.47,30.95c-0.27,3.72-0.17,16.39-0.03,26.37c0.08,5.55-0.599,11.07-2.02,16.43
 c-2.61,9.82-6.09,23.89-7.87,35.18c-2.81,17.7-7.16,59.49-7.209,59.9c-0.061,0.54-6.771,53.58-7.201,62.32l-0.009,0.24l0.219,0.08
 c19.781,7.66,36.8,9.48,48.52,9.48c1.261,0,2.46-0.02,3.59-0.06c12.54-0.41,20.69-2.87,21.131-3.4c0.619-0.74,4-15.66,5.419-32.04
 c1.4-16.15,10.59-54.33,10.69-54.72c0.11-0.52,11.48-52.21,12.46-59.78c0.98-7.62,5.56-43.65,6.31-50.01
 c0.75-6.36,4.97-27.94,5.6-31.16c3.48,1.64,4.82,6.09,5.67,10.28l1.04,5.11c2.88,14.1,5.86,28.69,7.561,43.24
 c0.889,7.56,0.79,15.17,0.699,22.53c-0.05,3.4-0.09,6.91-0.04,10.39c0.11,8.24,0.47,16.43,0.83,24.1
 c0.49,10.63,1.04,20.07,1.67,28.85c1.07,15.09,1.19,50.25,1.2,50.66c0.05,0.26,0.76,2.56,10.42,3.85
 c10.16,1.36,20.35,1.78,35.61,2.09c0.49,0.01,0.99,0.01,1.47,0.01c15.3,0,24.98-4.8,25.08-4.85l0.16-0.08l0.02-0.18
 c0.02-0.25,2.06-25.11,1.2-33.01c-0.91-8.32-0.91-28.48,0.971-38.2c0.069-0.33,0.119-0.67,0.159-1.01c0.27-2.04,0.38-4.12,0.49-6.14
 l0.01-0.22c0.19-3.51,0.31-6.98,0.4-9.91c0.12-3.74,0.22-7.72,0.32-12.54c0.1-4.74,0.18-9.48,0.25-14.22
 c0.07-4.99,0.13-9.99,0.18-14.98c0.05-4.93,0.09-9.87,0.12-14.8c0.04-4.56,0.06-9.12,0.08-13.68c0.02-3.88,0.04-7.76,0.05-11.63
 l0.01-4.76c0-0.76,0.01-1.52,0.02-2.28C224.963,264.589,224.993,262.209,224.773,259.849 M157.873,45.209
 c0.1,0.04,0.171,0.14,0.171,0.25v18.26c-0.811-0.23-2.781-0.77-5.541-1.52c-0.53-1.04-1.06-2.08-1.6-3.12
 c-0.5-0.97-1.01-1.94-1.49-2.91c-0.73-1.44-1.01-3.13-0.79-4.75c0.2-1.51,0.9-2.64,1.72-3.87c0.59-0.87,1.04-1.46,1.48-2.03
 c0.4-0.51,0.81-1.05,1.31-1.78C154.713,44.219,156.303,44.709,157.873,45.209 M136.803,39.109c5.14,1.41,10.42,2.86,15.68,4.43
 c-0.439,0.63-0.81,1.12-1.17,1.58c-0.45,0.58-0.91,1.18-1.51,2.07c-0.86,1.29-1.6,2.5-1.82,4.14c-0.24,1.75,0.061,3.57,0.851,5.13
 c0.489,0.98,0.989,1.95,1.489,2.92c0.45,0.86,0.89,1.72,1.33,2.59c-4.63-1.26-11.18-3.03-18.3-4.9c0.58-2.81,2.52-12.41,2.67-14.76
 c0.12-1.7-0.29-2.89-0.64-3.59C135.853,38.849,136.334,38.979,136.803,39.109 M134.483,38.469c0.22,0.3,1.04,1.58,0.9,3.8
 c-0.18,2.66-2.79,15.3-2.82,15.43c-0.19,0.88-0.59,2.18-0.95,2.58l-5.74-1.19c-0.06-0.02-0.079-0.06-0.09-0.07
 c-0.01-0.02-0.02-0.06,0-0.09c0.48-0.88,0.81-2.4,0.82-2.47c0.11-0.52,2.65-12.81,2.83-15.52c0.12-1.84-0.33-3.27-0.67-4.05
 C130.683,37.419,132.584,37.949,134.483,38.469 M127.933,36.659c0.22,0.41,1,2.02,0.85,4.24c-0.14,2.19-1.94,11.12-2.58,14.3
 c-5.34-1.39-10.19-2.62-14.44-3.66l-5.12-1.2c-5.3-1.25-10.28-2.32-13.349-2.88c-1.5-0.28-3-0.55-4.511-0.81l-2.15-0.38
 c0.42-2.14,2.53-12.77,3.43-15.03c0.95-2.4,3.07-3.39,3.09-3.4l-0.01-0.02C105.113,30.559,116.653,33.479,127.933,36.659
  M116.003,53.259c-2.59,12.29-11.88,50.88-28.52,64.48c-3.92-31.97-4.68-42.69,2.8-70.16c0.97,0.17,1.93,0.34,2.9,0.52
 c3.05,0.55,8.03,1.63,13.31,2.87l5.12,1.2C113.013,52.519,114.483,52.879,116.003,53.259 M92.243,27.619
 c-0.78,0.51-2.06,1.56-2.78,3.38c-1.02,2.56-3.44,14.99-3.54,15.52c-0.01,0.07-0.29,1.61-0.089,2.63
 c-0.011,0.03-0.121,0.09-0.29,0.06l-8.141-1.59c-0.33-0.5-0.25-1.96-0.09-2.89c0.03-0.13,2.53-13.33,3.56-15.92
 c0.97-2.44,2.99-3,3.08-3.03C86.743,26.379,89.503,26.999,92.243,27.619 M56.863,28.609l0.33-1.6c0.29-1.4,0.56-2.81,0.82-4.21
 c0.15-0.77,0.31-1.34,0.63-1.63c0.2-0.18,0.57-0.37,1.62-0.17c7.75,1.45,15.25,2.97,22.61,4.55c-0.8,0.44-1.93,1.33-2.61,3.02
 c-1.03,2.6-3.4,15.07-3.58,16l-0.72-0.12c-0.09-0.02-0.379-0.08-0.669-0.14c-0.281-0.06-0.561-0.11-0.661-0.13
 c-1.51-0.26-3.01-0.51-4.52-0.77l-14.5-2.4c-0.5-0.08-1-0.16-1.5-0.23c-0.18-0.03-0.36-0.05-0.54-0.07
 C54.913,37.289,55.963,33.439,56.863,28.609 M41.753,66.569l31.72,3.11l-0.09,0.84l-31.9-3.21
 C41.573,67.069,41.663,66.819,41.753,66.569 M41.243,67.939l32.08,3.22l-2.19,21.58c-0.11,0.09-0.31,0.24-0.57,0.43h-0.03v0.03
 c-1.78,1.35-6.37,4.82-7.08,5.35l-29.25-2.93C35.443,87.099,37.643,77.779,41.243,67.939 M36.533,144.409
 c-0.08-0.86-0.23-1.72-0.46-2.55c-1.29-4.7-5.27-22.01-1.96-45.6l29.39,2.94v-0.01c0.27-0.06,1-0.62,4.17-3.01
 c0.03-0.02,1.6-1.21,2.77-2.09l-4.59,45.19c-0.72,0.72-7,6.96-7.91,7.84l-21.359-2.15C36.573,144.779,36.553,144.579,36.533,144.409
  M16.003,469.439c0.541-9.39,7.12-61.5,7.19-62.04c0.04-0.42,4.4-42.2,7.2-59.88c1.88-11.85,5.73-27.09,7.86-35.11
 c1.43-5.42,2.12-11,2.041-16.61c-0.111-8.16-0.261-22.42,0.029-26.31c0.32-4.28,1.29-19.17,0.471-31.05
 c-0.131-1.93-0.311-4.31-0.521-7.02c-0.95-12.58-2.55-33.64-2.46-52.29c0.08-16.66-0.72-28.31-1.17-33.5l21.39,2.16h0.08l0.08-0.03
 c0.13-0.06,8.25-8.14,8.29-8.3l4.67-45.91c0.3-0.23,0.5-0.38,0.51-0.4l0.09-0.08l2.28-22.49l0.15-1.48l-32.19-3.16
 c2.22-5.79,4.92-11.74,8.23-17.81l3.17-6.79c0.21,0.02,0.42,0.05,0.63,0.08c0.49,0.07,0.99,0.15,1.49,0.23l14.49,2.4
 c1.51,0.26,3.02,0.51,4.52,0.77c0.09,0.02,0.37,0.07,0.64,0.13c0.3,0.06,0.59,0.12,0.69,0.14l0.74,0.12
 c-0.11,0.87-0.18,2.32,0.39,2.93l0.07,0.07l8.37,1.64c0.07,0.01,0.14,0.02,0.21,0.02c0.26,0,0.5-0.09,0.661-0.25
 c0.149-0.16,0.219-0.37,0.179-0.59c-0.139-0.67-0.02-1.66,0.05-2.12l2.15,0.38c0.32,0.05,0.65,0.11,0.97,0.17
 c-7.52,27.64-6.64,39.12-2.74,70.93l-2.24,31.36l-7.31-0.82l-0.23,2.05h0.03c-0.02,0.06-0.04,0.11-0.05,0.18l-0.95,8.3l-24.05-2.68
 l-0.03,0.32c-1.57,13.25-5.14,46.11-7.27,65.75c-0.81,7.56-1.44,13.34-1.7,15.65l-0.04,0.33l30.67,3.27
 c-3.2,26.74-5.3,41.88-8.49,55.08c-11.22,46.49-26.78,171.4-27.69,178.72C30.853,474.459,23.643,472.379,16.003,469.439
  M87.033,225.429c0.37,0.36,0.86,0.61,1.43,0.68l19.39,2.16c0.09,0.01,0.18,0.01,0.28,0.01c0.54,0,1.04-0.18,1.44-0.48l-1.94,17.47
 l-17.64-2.08l-4.89-0.53L87.033,225.429z M86.993,223.679l3.301-29.57l22.819,2.54l-3.29,29.57c-0.1,0.88-0.95,1.52-1.9,1.4
 l-19.39-2.16C87.584,225.359,86.893,224.559,86.993,223.679 M110.343,226.799c0.06-0.16,0.1-0.33,0.12-0.5l2.74-24.54l6.85,0.77
 l-4.85,43.52l0.65,0.07l4.92-44.17l-7.5-0.83l0.561-5.04l-24.121-2.69l-0.56,5.04l-7.5-0.84l-4.93,44.17l0.65,0.07l4.85-43.52
 l6.861,0.76l-2.741,24.54c-0.04,0.34,0.01,0.67,0.13,0.97l-2.01,18.01l-10-1.06v-0.04l-0.65-0.07v0.04l-6.15-0.66l4.31-38.66
 l-23.97-2.67c1.76-16.15,3.63-33.15,4.67-41.97l23.4,2.61l-2.57,22.42c-0.01,0.12,0.02,0.23,0.081,0.33
 c0.199,0.3,1.059,1.23,2.439,2.73c1.42,1.53,3.18,3.43,3.46,3.91c0.08,0.14,0.23,0.23,0.39,0.25l44.06,5.07h0.06
 c0.16,0,0.301-0.07,0.4-0.19c0.34-0.43,2.08-1.83,3.48-2.96c0.27-0.22,0.51-0.42,0.74-0.6c-1.569,13.96-3.35,29.56-4.64,40.95
 c-0.82,7.13-1.44,12.6-1.71,14.98l-13.99-1.65L110.343,226.799z M67.013,240.729l-23.23-2.48c0.28-2.49,0.89-8.1,1.67-15.32
 c0.71-6.54,1.58-14.55,2.48-22.81l23.32,2.6L67.013,240.729z M127.473,191.159c-1.52,1.22-3.08,2.49-3.53,3l-43.94-5.05
 c-0.35-0.55-1.68-2-3.5-3.96c-1.03-1.11-2.09-2.26-2.35-2.6l3.58-31.18l55.78,6.44l-3.59,31.3
 C129.663,189.379,128.553,190.289,127.473,191.159 M77.803,150.729l0.12-1.08l55.81,6.22l-0.149,1.3L77.803,150.729z
  M123.023,279.359c-0.74,6.35-5.33,42.37-6.31,50c-0.97,7.54-12.33,59.2-12.45,59.71c-0.09,0.38-9.29,38.61-10.69,54.82
 c-1.42,16.3-4.779,30.92-5.239,31.64c-0.171,0.12-19.811,6.9-50.141,0.52c0.82-6.65,16.44-132.13,27.69-178.72
 c3.19-13.23,5.3-28.39,8.5-55.16l15.55,1.66l32.91,3.89l0.05-0.51c0.26-2.3,0.89-7.85,1.72-15.12c1.32-11.56,3.14-27.49,4.721-41.61
 c0.599-0.49,0.979-0.83,1.119-0.98c0.06-0.08,0.1-0.17,0.11-0.27l3.61-31.49c0.01-0.06,0-0.12-0.02-0.18h0.04l0.25-2.26l-49.13-5.48
 l2.231-31.28c17.019-13.47,26.459-52.67,29.089-65.12c2.94,0.74,6.09,1.55,9.44,2.42c-0.06,0.3-0.1,0.48-0.1,0.49
 c-0.01,0.02-0.32,1.49-0.76,2.29c-0.11,0.21-0.12,0.45-0.02,0.67c0.11,0.22,0.31,0.38,0.55,0.43l6.03,1.25l0.11-0.07
 c0.73-0.48,1.22-2.64,1.32-3.07c0-0.02,0.01-0.07,0.02-0.12c12.4,3.26,23.1,6.21,24.81,6.68l-1.05,36.79
 c-0.27,8.82-0.53,16.34-0.68,18.58c-0.44,6.49-2.969,27.59-5.78,42.61l-3.08,12.05c-0.31,1.23-1.359,5.08-2.8,10.4
 c-14.14,52.11-16.19,61.38-15.93,62.97C128.483,248.939,123.813,272.609,123.023,279.359 M180.443,448.349
 c-8.38-0.32-15.22-0.81-22.03-1.72c-9.04-1.2-9.85-3.26-9.86-3.26c0-0.2-0.04-9.08-0.2-19.8c-0.17-10.73-0.47-23.3-1.01-30.85
 c-0.62-8.77-1.17-18.2-1.66-28.83c-0.36-7.67-0.72-15.84-0.84-24.08c-0.04-3.48,0-6.98,0.05-10.37c0.09-7.38,0.191-15.01-0.7-22.62
 c-1.71-14.58-4.69-29.17-7.57-43.29l-1.039-5.11c-0.901-4.47-2.361-9.24-6.331-10.88c-0.16-2.94,11.15-44.62,16.02-62.55
 c1.44-5.32,2.49-9.17,2.8-10.41l2.52-9.85c0.31,3.34,1.51,11.13,5.73,28.72c10.12,23.14,17.58,80.5,17.65,81.04
 c0,0.25,0.48,25.56,4.58,54.48C182.523,356.959,180.584,442.329,180.443,448.349 M224.273,266.879c-0.01,0.77-0.02,1.53-0.02,2.29
 l-0.01,4.75c-0.01,3.88-0.03,7.76-0.05,11.63c-0.02,4.56-0.05,9.12-0.08,13.68c-0.029,4.94-0.069,9.87-0.12,14.8
 c-0.05,4.99-0.11,9.99-0.18,14.98c-0.07,4.74-0.15,9.48-0.25,14.22c-0.1,4.81-0.2,8.79-0.32,12.53c-0.09,2.93-0.21,6.39-0.4,9.89
 l-0.009,0.22c-0.111,2.01-0.221,4.08-0.481,6.1c-0.04,0.32-0.09,0.65-0.15,0.97c-2.06,10.63-1.81,30.9-0.99,38.39
 c0.82,7.48-1,30.39-1.18,32.7c-1.37,0.64-11.22,4.98-26.09,4.69c-4.72-0.1-8.96-0.21-12.85-0.35c0.14-5.95,2.09-91.43-1.89-119.49
 c-4.1-28.88-4.58-54.15-4.58-54.44c-0.079-0.58-7.55-58.03-17.68-81.2c-6.39-26.61-5.81-30.58-5.78-30.73l-0.17-0.04l0.17,0.03
 c2.81-15.05,5.34-36.19,5.79-42.7c0.14-2.13,0.381-9.04,0.64-17.29c0.09,0.16,0.19,0.32,0.28,0.48c0.8,1.38,1.6,2.76,2.39,4.15
 c1.24,2.18,2.47,4.37,3.69,6.56c1.61,2.89,3.19,5.78,4.77,8.67c1.88,3.47,3.77,6.99,5.611,10.48c2.099,4,4.189,8.03,6.21,11.98
 c2.239,4.41,4.459,8.85,6.579,13.19c2.33,4.75,4.59,9.49,6.73,14.1c2.32,5,4.55,9.95,6.63,14.7c2.23,5.12,4.351,10.17,6.3,15.01
 c2.11,5.25,3.98,10.16,5.73,15.02c1.87,5.18,3.48,9.99,4.94,14.73c1.55,5.01,2.83,9.63,3.92,14.13l0.14,0.6
 c1.08,4.45,2.19,9.06,2.61,13.6C224.343,262.229,224.313,264.599,224.273,266.879"
      />
      <path
        fill="#010101"
        d="M484.843,234.379c0-0.62-0.21-62.15-3.98-122.56c-2.77-44.57-8.34-64.27-11.46-72.11
 c0.29-0.91,0.31-2.28,0.32-2.62c0-0.53-0.01-13.08-0.38-15.77c-0.39-2.8-1.85-3.84-1.91-3.88l-0.08-0.05l-2.18-0.11l-0.01,0.32
 l-0.01-0.32c-73.64,1.44-144.48,0.9-159.46,0.67l-2.52-0.05c-0.77,0.02-1.47,0.42-1.93,1.1c-0.51,0.75-0.86,1.66-1.03,2.72
 c-0.42,2.62-0.67,14.89-0.68,15.41c0,0.35,0,1.81,0.32,2.69c-3.05,7.95-8.47,27.73-11.23,72c-0.59,9.41-1.12,19.43-1.59,29.77
 l-0.18,3.95c-0.4,9.16-0.75,18.75-1.06,28.49l-0.17,6c-0.9,31.23-0.97,54.12-0.97,54.34l-1.11,62.44c-0.03,2.1,0.03,4.22,0.2,6.3
 c0.47,5.85,0.73,19.07,0.94,29.7c0.16,7.8,0.29,14.54,0.47,16.69c0.49,6.05,1.51,45.52,1.52,45.92c0.02,0.53,1.3,54.01,1.79,62.53
 c0.49,8.6,1.32,16.46,1.85,17.51c0.44,0.87,14.59,2.62,26.57,3.28c4,0.22,8.46,0.38,13.06,0.38c10.28,0,21.22-0.79,29.09-3.42
 c0.25-0.08,0.44-0.3,0.49-0.56c0.89-5.05,4.93-40.46,5.59-60.42c0.66-19.66,0.31-68.79-0.22-75.09c-0.52-6.3,0.21-38.14,1.85-46.16
 c1.03-5.06,2.13-19.64,3.02-31.35c0.54-7.11,1-13.25,1.31-15.44c0.29-1.99,0.39-5.78,0.53-10.59c0.25-8.98,0.6-21.27,2.45-28.12
 c1.98-7.35,3.3-15.97,4.09-21.13c0.33-2.14,0.56-3.68,0.71-4.21c0.11-0.4,0.17-1.73,0.28-4.45c0.34-8.18,1.14-27.33,5.64-29.25
 c4.45,1.92,5.25,21.07,5.59,29.25c0.11,2.72,0.17,4.05,0.28,4.45c0.14,0.53,0.38,2.07,0.71,4.21c0.04,0.26,0.08,0.54,0.12,0.81
 c-0.01,0.23-0.02,0.38-0.02,0.4h0.08c0.81,5.23,2.08,13.12,3.91,19.92c1.85,6.85,2.2,19.14,2.45,28.12
 c0.13,4.81,0.24,8.6,0.52,10.59c0.32,2.19,0.79,8.46,1.33,15.73c0.88,11.93,1.99,26.77,3.02,31.82c1.65,8.08,2.04,39.98,1.52,46.17
 c-0.36,4.35,0.67,31.22,1.51,52.82c0.31,8.1,0.6,15.75,0.78,21.18c0.66,19.75,2.48,55.56,3.4,60.74c0.05,0.26,0.23,0.48,0.49,0.56
 c11.39,3.81,29.21,3.75,42.15,3.04c11.98-0.66,26.13-2.41,26.57-3.28c0.52-1.05,1.35-8.9,1.85-17.51
 c0.49-8.52,1.14-61.89,1.14-62.43c0.01-0.39,0.82-39.75,1.31-45.8c0.35-4.31,1.42-26.84,2.06-40.3c0.25-5.3,0.43-9.13,0.46-9.49
 L484.843,234.379z M484.183,232.239l-9.15,0.04v-38.9h-26.52c-0.04-16.24-0.07-33.35-0.01-42.23h25.95l-0.07,22.57
 c0,0.12,0.04,0.24,0.13,0.33c0.25,0.28,1.3,1.11,3,2.44c1.73,1.36,3.89,3.06,4.25,3.5c0.1,0.13,0.26,0.2,0.42,0.2h1.04
 C483.963,205.959,484.143,225.879,484.183,232.239 M474.383,194.029v38.25l-25.75,0.11c0-2.52-0.02-8.18-0.05-15.48
 c-0.02-6.56-0.05-14.59-0.07-22.88H474.383z M483.153,177.759l-0.01-0.01l-0.03-0.02l-0.42,0.5l0.03,0.02
 c0.05,0.05,0.1,0.08,0.13,0.11l0.03,0.03l0.28-0.33c0.01,0.49,0.03,0.99,0.04,1.48h-0.97c-0.44-0.5-2.08-1.79-4.32-3.56
 c-1.26-0.99-2.56-2.01-2.88-2.33l0.1-31.36l6.71,0.02C482.403,154.739,482.823,166.739,483.153,177.759 M481.813,141.659l-6.67-0.02
 v-1.09h6.62C481.773,140.919,481.793,141.289,481.813,141.659 M465.153,17.929l1.97,0.1c0.27,0.22,1.27,1.21,1.58,3.38
 c0.36,2.64,0.37,15.55,0.37,15.68c-0.01,0.9-0.14,2.26-0.41,2.72h-5.87c-0.05,0-0.08-0.03-0.09-0.05c-0.02-0.02-0.03-0.05-0.02-0.09
 c0.29-0.96,0.3-2.51,0.3-2.58c0-0.53,0-13.08-0.37-15.77c-0.24-1.71-0.87-2.75-1.35-3.32
 C462.563,17.969,463.853,17.949,465.153,17.929 M408.413,18.699c16.59-0.14,34.16-0.36,51.97-0.69c0.23,0.2,1.27,1.17,1.58,3.4
 c0.31,2.21,0.36,11.59,0.37,14.68l-2.86,0.06c-16.23,0.62-33.88,1.06-51.06,1.28V18.699z M393.403,18.799
 c4.69-0.03,9.47-0.06,14.35-0.1v21.38c0,0.35-0.28,0.64-0.64,0.64h-13.07c-0.35,0-0.64-0.29-0.64-0.64V18.799z M360.483,18.889
 c4.59,0,9.39-0.01,14.35-0.02v21.21c0,0.35-0.29,0.64-0.64,0.64h-13.07c-0.35,0-0.64-0.29-0.64-0.64V18.889z M309.333,18.649
 c9.12,0.11,27.17,0.24,50.46,0.24h0.04v18.41c-21.22-0.28-38.02-0.79-48.83-1.15l-4.06-0.05c0.08-3.26,0.31-11.99,0.65-14.08
 C307.933,19.899,309.043,18.889,309.333,18.649 M300.853,21.829c0.16-0.97,0.47-1.8,0.92-2.47c0.34-0.5,0.86-0.79,1.4-0.81l2.5,0.05
 c0.77,0.02,1.69,0.03,2.74,0.04c-0.51,0.58-1.2,1.62-1.46,3.27c-0.43,2.62-0.67,14.89-0.69,15.41c0,0.07-0.02,1.72,0.29,2.66
 l-6.02-0.17c-0.26-0.45-0.36-1.79-0.35-2.67C300.193,37.019,300.443,24.399,300.853,21.829 M287.743,140.289l4.2,0.15l-0.04,1.08
 l-4.21-0.12C287.713,141.029,287.723,140.659,287.743,140.289 M286.443,174.049c0.31-9.74,0.66-19.32,1.06-28.48l0.16-3.53l4.22,0.1
 l-0.96,31.39c-0.33,0.3-1.66,1.27-2.94,2.21c-0.54,0.4-1.09,0.8-1.62,1.2L286.443,174.049z M286.263,180.049l0.07-2.29
 c0.65-0.48,1.36-1,2.03-1.49c1.73-1.27,2.81-2.06,3.07-2.33c0.09-0.09,0.14-0.21,0.14-0.33l0.69-22.56l25.94,0.88
 c-0.37,13.55-1.59,46.22-2.32,65.81c-0.27,7.25-0.48,12.88-0.57,15.39l-30-1.15C285.353,225.319,285.543,205.439,286.263,180.049
  M384.343,148.398c-4.72,2.34-5.49,20.83-5.86,29.75c-0.09,2.21-0.16,3.96-0.26,4.31c-0.11,0.39-0.25,1.22-0.44,2.43
 c-0.42-8.76-1.54-32.96-1.19-36.19c0.23-2.14,1.93-3.57,2.92-4.23c1.62-1.08,3.55-1.6,4.83-1.33V148.398z M384.343,142.479
 c-1.45-0.25-3.46,0.3-5.19,1.45c-1.87,1.25-3.01,2.92-3.21,4.7c-0.42,3.98,1.28,38,1.35,39.45c-0.4,2.61-0.92,5.85-1.56,9.29
 c-0.64,3.44-1.4,7.07-2.31,10.43c-1.87,6.93-2.22,19.26-2.47,28.27c-0.13,4.6-0.24,8.57-0.52,10.52c-0.32,2.21-0.78,8.36-1.32,15.48
 c-0.88,11.7-1.98,26.25-3.01,31.27c-1.64,8.05-2.38,40.02-1.86,46.35c0.53,6.28,0.88,55.36,0.22,75.01
 c-0.66,19.94-4.69,55.29-5.58,60.33c-0.01,0.02-0.03,0.05-0.06,0.06c-21.29,7.1-66.06,0.85-67.95,0.02
 c-0.44-1.1-1.25-8.27-1.76-17.2c-0.5-8.5-1.77-61.97-1.79-62.51c-0.01-0.4-1.03-39.88-1.53-45.95c-0.17-2.14-0.3-8.86-0.46-16.65
 c-0.21-10.64-0.47-23.87-0.94-29.75c-0.17-2.06-0.23-4.15-0.2-6.23l1.11-62.44c0-0.04,0-0.64,0.01-1.75l30.63,1.17l0.01-0.33
 c0.08-2.32,0.29-8.12,0.58-15.71c0.74-19.74,1.97-52.78,2.33-66.13v-0.32l-26.58-0.91l0.26-8.35c0-0.06-0.01-0.12-0.03-0.18h0.03
 l0.07-2.06l-4.84-0.16c0.45-9.64,0.95-18.98,1.5-27.79c2.71-43.47,7.98-63.25,11.04-71.41l6.32,0.18h0.02
 c0.17,0,0.34-0.08,0.44-0.23c0.13-0.17,0.16-0.4,0.09-0.6c-0.28-0.82-0.27-2.45-0.27-2.47c0-0.01,0.01-0.22,0.02-0.58l4.06,0.05
 c10.8,0.36,27.61,0.87,48.84,1.15v2.13c0,0.71,0.58,1.29,1.29,1.29h13.07c0.71,0,1.29-0.58,1.29-1.29v-1.98l8.73,0.07l0.13,25.5
 V142.479z M377.773,37.459l-2.29-0.01v-18.58c5.56-0.01,11.33-0.04,17.27-0.07v18.76l-2.54,0.01L377.773,37.459z M391.273,182.459
 c-0.1-0.35-0.17-2.1-0.26-4.31c-0.38-9-1.16-27.73-5.98-29.82c-0.01,0-0.03,0-0.04-0.01v-5.17c1.26-0.3,3.24,0.22,4.89,1.32
 c0.99,0.66,2.69,2.09,2.92,4.23c0.34,3.17-0.73,26.59-1.17,35.72C391.483,183.459,391.363,182.789,391.273,182.459 M484.893,309.388
 c-0.64,13.45-1.71,35.98-2.06,40.28c-0.49,6.07-1.3,45.44-1.31,45.84c0,0.54-0.65,53.9-1.14,62.4c-0.51,8.93-1.33,16.11-1.76,17.2
 c-1.89,0.83-46.67,7.08-67.96-0.02c-0.02-0.01-0.04-0.04-0.05-0.07c-0.91-5.15-2.73-40.91-3.39-60.64
 c-0.18-5.43-0.47-13.08-0.79-21.19c-0.83-21.57-1.86-48.43-1.5-52.74c0.52-6.2,0.12-38.23-1.53-46.35
 c-1.02-5.01-2.13-19.83-3.02-31.74c-0.54-7.28-1.01-13.56-1.32-15.77c-0.28-1.95-0.39-5.92-0.52-10.52
 c-0.25-9.01-0.6-21.34-2.47-28.27c-1.87-6.92-3.15-14.98-3.95-20.18c0.22-4.27,1.73-35.21,1.33-38.99c-0.2-1.78-1.34-3.45-3.21-4.7
 c-1.75-1.17-3.81-1.71-5.25-1.44v-78.79l-0.13-25.52l5.35,0.04l2.54-0.01v1.87c0,0.71,0.58,1.29,1.29,1.29h13.07
 c0.71,0,1.3-0.58,1.3-1.29v-2c17.19-0.22,34.85-0.66,51.08-1.28l2.84-0.06v0.35c0,0.02-0.01,1.52-0.27,2.39
 c-0.07,0.23-0.03,0.47,0.12,0.67c0.14,0.19,0.37,0.31,0.61,0.31h6.17l0.02-0.03c2.63,6.84,8.44,26.49,11.24,71.43
 c0.58,9.4,1.08,18.82,1.51,28.04h-7.24v2.06h0.03c-0.02,0.06-0.04,0.12-0.04,0.18l-0.02,8.36h-26.6l-0.01,0.32
 c-0.09,13.33,0.02,46.36,0.08,66.09c0.03,7.63,0.05,13.48,0.05,15.81v0.32l36.2-0.15c0.01,0.92,0.01,1.44,0.01,1.49l1.16,65.57
 C485.323,300.249,485.153,303.879,484.893,309.388"
      />
      <path
        fill="#010101"
        d="M303.013,59.409l-0.33-0.02l-0.07,1.65l-1.07,22.57l0.28-0.12c0.01,0.01,0.03,0.03,0.05,0.04l-2.22,46.41
 h0.039c0.121,0.35,0.861,1.32,3.451,4.7c1.61,2.1,3.44,4.49,3.49,4.55l0.08,0.19l55.37,2.61l0.09,0.01l0.08-0.05
 c0.12-0.06,7.79-8.57,7.82-8.72l2.21-46.1c0.29-0.24,0.48-0.41,0.5-0.42l0.08-0.09l1.06-22.25l0.01-0.08l0.009-0.25l0.061-1.49
 L303.013,59.409z M369.433,133.079c-0.67,0.76-6.61,7.32-7.47,8.26l-54.86-2.59c-0.25-0.34-1.03-1.36-3.45-4.51
 c-1.421-1.86-3.01-3.94-3.35-4.38l2.19-45.69c1.779,1.83,5.92,6.18,6.04,6.3l0.09,0.1l56.33,2.62v-0.02c0.26-0.07,0.97-0.67,4-3.23
 c0.029-0.02,1.54-1.29,2.65-2.23L369.433,133.079z M372.232,86.319c-0.109,0.1-0.299,0.26-0.549,0.47h-0.03v0.03
 c-1.711,1.44-6.1,5.15-6.79,5.71l-55.95-2.59c-0.4-0.43-1.95-2.06-3.34-3.5c-2.08-2.18-2.95-3.09-3.35-3.44l1.02-21.61l70.02,3.27
 L372.232,86.319z M373.293,64.009l-70.021-3.26l0.031-0.68l70.02,3.1L373.293,64.009z"
      />
      <path
        fill="#010101"
        d="M467.913,83.529c0.01-0.01,0.03-0.03,0.05-0.04l0.28,0.12l-1.07-22.57l-0.08-1.65l-70.99,3.15l-0.32,0.01
 l0.06,1.49l0.01,0.25l0.01,0.08l1.05,22.25l0.09,0.09c0.01,0.01,0.21,0.18,0.5,0.42l2.22,46.16c0.02,0.1,7.69,8.6,7.81,8.66
 l0.08,0.05l55.25-2.61l0.17,0.06l0.08-0.2c0.09-0.12,1.92-2.51,3.53-4.61c2.59-3.38,3.33-4.35,3.45-4.7h0.04L467.913,83.529z
  M396.453,63.169l70.02-3.1l0.03,0.68l-70.01,3.26L396.453,63.169z M398.103,86.789c-0.26-0.21-0.45-0.38-0.55-0.46l-1.03-21.67
 l70.01-3.27l1.03,21.61c-0.4,0.36-1.27,1.26-3.36,3.44c-1.39,1.46-2.94,3.08-3.34,3.5l-55.94,2.59c-0.69-0.56-5.09-4.28-6.79-5.71
 v-0.03H398.103z M466.123,134.239c-2.41,3.15-3.19,4.17-3.45,4.51l-54.85,2.59c-0.86-0.94-6.77-7.47-7.47-8.26l-2.18-45.37
 c1.12,0.94,2.63,2.21,2.65,2.23c3.04,2.56,3.75,3.16,4,3.23l0.01,0.02l56.19-2.61l0.14-0.01l0.09-0.09c0.29-0.32,4.3-4.52,6.04-6.31
 l2.19,45.69C469.143,130.299,467.553,132.379,466.123,134.239"
      />
    </svg>
  );
}
